export default {
    ENV: import.meta.env.NEXTGEN_ENV,
    APP_TYPE: import.meta.env.NEXTGEN_APP_TYPE,
    MARKET_CODE: import.meta.env.NEXTGEN_MARKET_CODE,

    DEVICE_CONFIG_HOST: import.meta.env.NEXTGEN_DEVICE_CONFIG_HOST,
    DEVICE_HUB_ENV: import.meta.env.NEXTGEN_DEVICE_HUB_ENV,
    DEVICE_HUB_SUBDOMAIN: import.meta.env.NEXTGEN_DEVICE_HUB_SUBDOMAIN,

    CONSOLE_LOG_LEVEL: import.meta.env.NEXTGEN_CONSOLE_LOG_LEVEL,
    CLOUD_WATCH_LOG_LEVEL: import.meta.env.NEXTGEN_CLOUD_WATCH_LOG_LEVEL,
    CLOUD_WATCH_UNAUTHORIZED_LOG_GROUP: import.meta.env.NEXTGEN_CLOUD_WATCH_UNAUTHORIZED_LOG_GROUP,

    IAP_BACKEND_API: import.meta.env.NEXTGEN_IAP_BACKEND_API,
    IAP_CONSENTS_CLOUDFRONT_URL: import.meta.env.NEXTGEN_IAP_CONSENTS_CLOUDFRONT_URL,
    IAP_CONFIGURATION_CLOUDFRONT_URL: import.meta.env.NEXTGEN_IAP_CONFIGURATION_CLOUDFRONT_URL,

    AWS_PROJECT: import.meta.env.NEXTGEN_AWS_PROJECT,

    AWS_AUTH_IDENTITY_POOL_ID: import.meta.env.NEXTGEN_AWS_AUTH_IDENTITY_POOL_ID,
    AWS_REGION: import.meta.env.NEXTGEN_AWS_REGION,
    AWS_AUTH_POOL_ID: import.meta.env.NEXTGEN_AWS_AUTH_POOL_ID,
    AWS_AUTH_USER_POOL_WEB_CLIENT_ID: import.meta.env.NEXTGEN_AWS_AUTH_USER_POOL_WEB_CLIENT_ID,
    AWS_AUTH_AUTHENTICATION_FLOW_TYPE: import.meta.env.NEXTGEN_AWS_AUTH_AUTHENTICATION_FLOW_TYPE,
    AWS_RUM_APPLICATION_ID: import.meta.env.NEXTGEN_AWS_RUM_APPLICATION_ID,
    AWS_RUM_APPLICATION_ID_IQOS_DOMAIN: import.meta.env.NEXTGEN_AWS_RUM_APPLICATION_ID_IQOS_DOMAIN,
    INC_CLOUD_PROJECT: import.meta.env.NEXTGEN_INC_CLOUD_PROJECT,
    INC_CLOUD_API_ENDPOINT: import.meta.env.NEXTGEN_INC_CLOUD_API_ENDPOINT,
    INC_SHARED_API_ENDPOINT: import.meta.env.NEXTGEN_INC_SHARED_API_ENDPOINT,

    UAMF_API_ENDPOINT: import.meta.env.NEXTGEN_UAMF_API_ENDPOINT,
    UAMF_API_KEY: import.meta.env.NEXTGEN_UAMF_API_KEY,
    UAMF_PROJECT: import.meta.env.NEXTGEN_UAMF_PROJECT,

    SIDEWALK_API_ENDPOINT: import.meta.env.NEXTGEN_SIDEWALK_API_ENDPOINT,

    WEB_PUSH_PUBLIC_KEY: import.meta.env.NEXTGEN_WEB_PUSH_PUBLIC_KEY,

    SCANDIT_KEY: import.meta.env.NEXTGEN_SCANDIT_KEY,

    UWM_URL: import.meta.env.NEXTGEN_UWM_URL,
    UWM_IAP_APP_TYPE: import.meta.env.NEXTGEN_UWM_IAP_APP_TYPE,

    VOXLINK_API_ENDPOINT: import.meta.env.NEXTGEN_VOXLINK_API_ENDPOINT,
};
